(() => {
  const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
  let controller;
  const init = () => {
    if (controller) controller.abort();
    controller = new AbortController();
    const { signal } = controller;
    const root = document.getElementById('x-header');
    const menus = Array.from(document.querySelectorAll('#x-header details[data-afr-dropdown], .afr-medium-navigation details[data-afr-dropdown]'));
    const timers = new Map();
    const openingTimers = new Map();
    const cancelOpen = menu => {
      clearTimeout(openingTimers.get(menu));
      openingTimers.delete(menu);
    };
    const hoverOpened = new WeakSet();
    const cancelClose = menu => {
      clearTimeout(timers.get(menu));
      timers.delete(menu);
    };
    const closeMenu = menu => {
      cancelOpen(menu);
      hoverOpened.delete(menu);
      clearTimeout(timers.get(menu));
      timers.delete(menu);
      menu.open = false;
    };
    const close = except => menus.forEach(menu => {
      if (menu !== except) closeMenu(menu);
    });
    const openMenu = menu => {
      cancelOpen(menu);
      cancelClose(menu);
      close(menu);
      menu.open = true;
    };
    signal.addEventListener('abort', () => {
      menus.forEach(menu => {
        clearTimeout(timers.get(menu));
        cancelOpen(menu);
      });
      timers.clear();
      openingTimers.clear();
    }, { once: true });
    menus.forEach(menu => {
      menu.querySelector('summary')?.addEventListener('click', event => {
        event.preventDefault();
        cancelOpen(menu);
        if (event.detail > 0 && hoverOpened.has(menu)) {
          hoverOpened.delete(menu);
          return;
        }
        hoverOpened.delete(menu);
        if (menu.open) closeMenu(menu);
        else openMenu(menu);
      }, { signal });
      menu.addEventListener('pointerenter', () => {
        if (!hover.matches) return;
        cancelClose(menu);
        cancelOpen(menu);
        if (menu.open) return;
        const reveal = () => {
          openingTimers.delete(menu);
          if (signal.aborted || !menu.isConnected || !menu.matches(':hover')) return;
          hoverOpened.add(menu);
          openMenu(menu);
        };
        if (window.innerWidth >= 768) openingTimers.set(menu, setTimeout(reveal, 3000));
        else reveal();
      }, { signal });
      menu.addEventListener('pointerleave', () => {
        cancelOpen(menu);
        if (!hover.matches) return;
        clearTimeout(timers.get(menu));
        timers.set(menu, setTimeout(() => {
          if (!menu.contains(document.activeElement)) closeMenu(menu);
        }, 220));
      }, { signal });
      menu.addEventListener('toggle', () => {
        if (menu.open) close(menu);
      }, { signal });
      menu.addEventListener('focusin', () => {
        if (menu.open) cancelClose(menu);
      }, { signal });
      menu.addEventListener('focusout', event => {
        if (!menu.contains(event.relatedTarget)) closeMenu(menu);
      }, { signal });
    });
    document.addEventListener('pointerdown', event => {
      if (!menus.some(menu => menu.contains(event.target))) close();
    }, { signal });
    document.addEventListener('keydown', event => {
      const active = menus.find(menu => menu.open);
      if (event.key === 'Escape' && active) {
        event.preventDefault();
        event.stopPropagation();
        active.querySelector('summary')?.focus();
        close();
      }
    }, { capture: true, signal });
    hover.addEventListener('change', () => {
      menus.forEach(menu => closeMenu(menu));
    }, { signal });
    window.addEventListener('resize', () => {
      menus.forEach(cancelOpen);
    }, { signal });
    const browser = root && root.querySelector('[data-afr-category-browser]');
    const source = document.querySelector('[data-afr-products-source]');
    if (browser && source) {
      const overview = browser.querySelector('[data-afr-category-overview]');
      const preview = browser.querySelector('[data-afr-product-preview]');
      const status = browser.querySelector('[data-afr-products-status]');
      const result = browser.querySelector('[data-afr-products-result]');
      const fallback = browser.querySelector('[data-afr-products-fallback]');
      const links = Array.from(browser.querySelectorAll('.afr-category-rail a'));
      const cache = new Map();
      let previewTimer;
      let requestController;
      let selection = 0;
      let selectedHref;
      signal.addEventListener('abort', () => {
        clearTimeout(previewTimer);
        if (requestController) requestController.abort();
      }, { once: true });
      const select = async link => {
        if (selectedHref === link.href && result.childElementCount) return;
        selectedHref = link.href;
        const current = ++selection;
        if (requestController) requestController.abort();
        links.forEach(item => item.classList.toggle('is-active', item === link));
        overview.hidden = true;
        preview.hidden = false;
        status.textContent = browser.dataset.loading;
        status.hidden = false;
        fallback.hidden = true;
        fallback.href = link.href;
        result.replaceChildren();
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('section_id', source.dataset.afrProductsSection);
        const currentParams = new URL(window.location.href).searchParams;
        for (const key of ['preview_theme_id', '_fd', 'pb']) {
          if (currentParams.has(key)) url.searchParams.set(key, currentParams.get(key));
        }
        try {
          let content = cache.get(url.href);
          if (!content) {
            requestController = new AbortController();
            const response = await fetch(url.href, { signal: requestController.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error('Preview unavailable');
            const document = new DOMParser().parseFromString(await response.text(), 'text/html');
            content = document.querySelector('[data-afr-preview-products]');
            if (!content) throw new Error('Preview missing');
            cache.set(url.href, content);
          }
          if (current !== selection || signal.aborted) return;
          result.replaceChildren(content.cloneNode(true));
          status.hidden = true;
        } catch (error) {
          if (error.name === 'AbortError' || current !== selection || signal.aborted) return;
          status.textContent = browser.dataset.error;
          fallback.hidden = false;
        }
      };
      links.forEach(link => {
        link.addEventListener('pointerenter', () => {
          if (!hover.matches) return;
          clearTimeout(previewTimer);
          previewTimer = setTimeout(() => select(link), window.innerWidth >= 768 ? 3000 : 120);
        }, { signal });
        link.addEventListener('pointerleave', () => clearTimeout(previewTimer), { signal });
        link.addEventListener('focus', () => {
          clearTimeout(previewTimer);
          select(link);
        }, { signal });
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();